import * as fromRoute from '../actions/route.action';
import { IRouteState } from '../../shared/model/interfaces/store/route-state';

const defaultRouteState: IRouteState = {
  requestUrl: ''
};

export function reducer(state: IRouteState = defaultRouteState, action: fromRoute.RouteActions) {
  switch (action.type) {
    case fromRoute.SET_ROUTE:
      return { ...state, requestUrl: action.payload };
    default:
      return state;
  }
}
